export type TreatmentItem = {
  name: string;
  problem: string;
};

export type TreatmentCategory = {
  id: string;
  label: string;
  icon: string;
  intro: string;
  items: TreatmentItem[];
};

export const treatmentCategories: TreatmentCategory[] = [
  {
    id: "eye",
    label: "眼部療程",
    icon: "ri-eye-line",
    intro: "針對眼周細紋、眼袋、淚溝與眼皮鬆弛，溫和提拉重現明亮眼神。",
    items: [
      { name: "淚溝綻採精塑", problem: "淚溝" },
      { name: "眼周時光逆轉療程", problem: "眼袋" },
      { name: "琉光笑顏平滑術", problem: "魚尾紋" },
      { name: "星眸立體拉提術", problem: "眼皮提升" },
      { name: "多維明眸提塑", problem: "雙眼皮提升 / 多層雙眼皮提升" },
      { name: "雙瞳花漾精雕術", problem: "雙眼皮" },
    ],
  },
  {
    id: "antiaging",
    label: "抗衰老療程",
    icon: "ri-vip-diamond-line",
    intro: "重塑面部輪廓與緊緻度，改善鬆弛下垂，回復年輕飽滿線條。",
    items: [
      { name: "太陽穴豐夫妻旺財", problem: "太陽穴 / 夫妻宮" },
      { name: "雙下巴消滅技術", problem: "雙下巴" },
      { name: "輪廓立體精塑", problem: "側面輪廓線" },
      { name: "小V臉邊界重塑", problem: "下顎線" },
      { name: "富貴窩回春", problem: "老人窩 / 顴骨下" },
      { name: "頭面冠冕筋膜拉", problem: "全面大拉提（連頭）" },
      { name: "帝王無縫提拉術", problem: "全面大拉提（連頭連頸）" },
      { name: "毛囊活化逆齡拉提", problem: "頭皮衰老" },
    ],
  },
  {
    id: "skin",
    label: "皮膚療程（斑、痣、疣）",
    icon: "ri-contrast-drop-line",
    intro: "針對各類色素沉澱與皮膚瑕疵，還原勻淨透亮的健康膚色。",
    items: [
      { name: "星點無痕美學療程", problem: "痣" },
      { name: "絲滑無痕淨疣有術", problem: "疣" },
      { name: "歲月逆痕淨斑術", problem: "老年斑" },
      { name: "雀斑隱形瓷肌方案", problem: "雀斑" },
      { name: "真皮煥顏透亮術", problem: "真皮斑" },
      { name: "勻亮光燦活膚療程", problem: "黃褐斑" },
    ],
  },
  {
    id: "wrinkle",
    label: "祛紋及疤療程",
    icon: "ri-shield-cross-line",
    intro: "淡化各部位紋路與疤痕，包括產後妊娠紋及凸疤增生疤修復。",
    items: [
      { name: "川字貴人回春療程", problem: "川字紋" },
      { name: "鼻樑絲滑無紋術", problem: "鼻背紋" },
      { name: "天運鼻山雕塑", problem: "鼻樑提升" },
      { name: "額齡逆轉三部曲", problem: "抬頭紋" },
      { name: "笑紋淡化青春線", problem: "法令紋" },
      { name: "木偶痕歸零術", problem: "木偶紋（上下）" },
      { name: "蜜唇水潤無紋絲滑", problem: "唇紋" },
      { name: "頸部年輪熨平術", problem: "頸紋" },
      { name: "耳際旁青春拉提", problem: "耳前紋" },
      { name: "孕痕重生絲綢腹肌", problem: "妊娠紋" },
      { name: "疤痕浮雕刻療", problem: "凸疤 / 肥胖疤 / 開刀疤 / 增生疤" },
    ],
  },
];